/**
 * Touch-swipe support for CodeBlackBelt "Also Bought" carousel.
 * The app's JS handles touchstart/touchend but lacks touchmove,
 * so native finger-drag scrolling doesn't work. This script adds
 * swipe detection and triggers the app's own prev/next arrows.
 */
(function () {
  var SWIPE_THRESHOLD = 40; // px – minimum distance to count as a swipe
  var COOLDOWN = 400; // ms – ignore swipes during slide animation
  var HORIZONTAL_LOCK = 15; // px – minimum horizontal movement to lock axis

  // On mobile, native CSS scroll handles swiping — skip JS handler
  // to avoid touchmove preventDefault interfering with native scroll.
  var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;

  function bind(slider) {
    if (slider.dataset.swipeInit) return; // already bound
    slider.dataset.swipeInit = '1';
    if (isMobile) return;

    var startX = 0;
    var startY = 0;
    var tracking = false;
    var lastSwipeTime = 0;

    slider.addEventListener(
      'touchstart',
      function (e) {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      },
      { passive: true }
    );

    slider.addEventListener(
      'touchmove',
      function (e) {
        if (!tracking) return;
        // Cancel if a second finger appears
        if (e.touches.length !== 1) {
          tracking = false;
          return;
        }
        // Prevent vertical scroll when swiping horizontally
        var dx = Math.abs(e.touches[0].clientX - startX);
        var dy = Math.abs(e.touches[0].clientY - startY);
        if (dx > dy && dx > HORIZONTAL_LOCK) {
          e.preventDefault();
        }
      },
      { passive: false }
    );

    slider.addEventListener(
      'touchend',
      function (e) {
        if (!tracking) return;
        tracking = false;

        var endX = e.changedTouches[0].clientX;
        var diff = endX - startX;

        if (Math.abs(diff) < SWIPE_THRESHOLD) return;

        // Debounce rapid swipes to avoid animation stacking
        var now = Date.now();
        if (now - lastSwipeTime < COOLDOWN) return;
        lastSwipeTime = now;

        // Find the enclosing slider-container to locate arrows
        var container = slider.closest('.cbb-also-bought-slider-container');
        if (!container) return;

        if (diff < 0) {
          // Swiped left → advance (click "next")
          var next = container.querySelector('.cbb-also-bought-next');
          if (next) next.click();
        } else {
          // Swiped right → go back (click "prev")
          var prev = container.querySelector('.cbb-also-bought-prev');
          if (prev) prev.click();
        }
      },
      { passive: true }
    );
  }

  function init() {
    var sliders = document.querySelectorAll('.cbb-also-bought-slider');
    sliders.forEach(bind);
  }

  // Use MutationObserver to detect when the app injects its widget
  // instead of relying on fixed timeouts.
  function observe() {
    if (typeof MutationObserver === 'undefined') {
      // Fallback for very old browsers
      init();
      setTimeout(init, 2000);
      setTimeout(init, 5000);
      return;
    }

    var found = false;
    var observer = new MutationObserver(function () {
      var sliders = document.querySelectorAll(
        '.cbb-also-bought-slider:not([data-swipe-init])'
      );
      if (sliders.length) {
        sliders.forEach(bind);
        found = true;
      }
      // Disconnect once we've found and bound at least one slider —
      // the widget only injects once per page load.
      if (found) observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Also run immediately in case the widget already exists
    init();
    // If init() already found sliders, no need to keep observing
    if (document.querySelectorAll('.cbb-also-bought-slider[data-swipe-init]').length) {
      observer.disconnect();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
